/* Stands in for a module that is not on screen, for either of the two reasons
 * one can be missing: it has not been built yet, or this salon is not licensed
 * for it. With no active module at all, it says only that there are none.
 *
 * Both are honest about which. A placeholder that said "not on your plan" about
 * something nobody has written would send somebody to ask about buying it, and
 * a locked module that said "not built yet" would leave a customer thinking the
 * product does not have the thing they were shown.
 */
import * as Vue from 'vue';
import { apps } from '../apps.js';
import { licensing } from '../licensing.js';

export const ModuleStub = {
  name: 'ModuleStub',
  setup: function () {
    var app = apps.active;

    var locked = Vue.computed(function () { return apps.locked(app.value); });

    // Where to go instead: the modules this salon actually has. Empty when a
    // licence has lapsed entirely, which is the case the button has to not
    // offer — there is nowhere to go back to.
    var elsewhere = Vue.computed(function () { return apps.ready(); });

    function goBack() {
      var first = elsewhere.value[0];
      if (first) apps.setActive(first.id);
    }

    return {
      app: app,
      locked: locked,
      elsewhere: elsewhere,
      licence: licensing.summary,
      goBack: goBack
    };
  },
  template: [
    '<div class="stub">',
    /* Nothing is offered, so nothing is named: no module here is theirs. */
    '  <div v-if="!app" class="stub__card">',
    '    <h2>No modules enabled</h2>',
    '    <p class="stub__note">This account does not have any modules enabled. Please contact',
    '      support.</p>',
    '  </div>',
    '  <div v-else class="stub__card">',
    '    <span class="stub__icon" aria-hidden="true">{{ app.icon }}</span>',
    '    <h2>{{ app.name }}</h2>',
    '    <p class="stub__blurb">{{ app.blurb }}</p>',
    '',
    '    <template v-if="locked">',
    '      <p class="stub__note" v-if="licence.lapsed">This is not available because the',
    '        subscription for this business has <strong>ended</strong>. Nothing has been deleted',
    '        &mdash; everything comes back exactly as it was when it is renewed.</p>',
    '      <p class="stub__note" v-else>This module is not part of',
    '        {{ licence.planName ? "the " + licence.planName + " plan" : "this subscription" }}.',
    '        Nothing on this screen is missing or broken; it has simply not been switched on for',
    '        this business.</p>',
    '    </template>',
    '',
    '    <p v-else class="stub__note">This module has not been built yet &mdash; it is listed so',
    '      the switcher has somewhere to go. Nothing here reads or writes any data.</p>',
    '',
    '    <button v-if="elsewhere.length" type="button" class="btn btn--primary"',
    '      @click="goBack">Back to {{ elsewhere[0].name }}</button>',
    '  </div>',
    '</div>'
  ].join('\n')
};
